// LoadingScreen.js
import React, { useState, useEffect } from 'react';
import { useContext } from "react";
import { MyContext } from "../MainContext";
import { backendUrl } from "../utils/variables";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faPowerOff, faChartLine, faCog, faUsers, faUserMd, faWallet } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

const Header = () => {
    const { user, exit_user, adminData } = useContext(MyContext);
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);
    const [showDashboardMenu, setShowDashboardMenu] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    //console.log('Header - Component loaded, user:', user);
    //console.log('Header - Current adminData:', adminData);

  // Admin access is loaded via allowlist in MainContext (admin_emails.php)
  useEffect(() => {
    setIsAdmin(!!(adminData && adminData.role));
  }, [adminData]);

  //console.log('Current user:', user);
    //console.log('Is admin:', isAdmin);

    const exit_acc = () => {
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        setShowLogoutModal(false);
        exit_user();
        navigate("/");
    };

    const cancelLogout = () => {
        setShowLogoutModal(false);
    };

    const handleDashboardClick = (route) => {
        setShowDashboardMenu(false);
        navigate(route);
    };

    return (
        <>
            {/* Top Navigation */}
            <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
                <div className="container d-flex justify-content-between align-items-center">
                    {user && user.user_id ? (
                        <FontAwesomeIcon 
                            icon={faChevronLeft} 
                            onClick={() => {
                                if (window.history.length > 1) {
                                    navigate(-1); // Go back one page
                                } else {
                                    navigate("/"); // Navigate to the root URL
                                }
                            }} 
                        />
                    ) : (
                        <FontAwesomeIcon icon={faChevronLeft} onClick={() => navigate("/")} />
                    )}

                    <a className="navbar-brand mx-auto" onClick={() => navigate("/")}>
                        <img 
                            src={`${process.env.PUBLIC_URL}/logo_wordmark_color.svg`} 
                            alt="Placeholder Image" 
                            className="img-fluid hm-logo" 
                            style={{ maxWidth: '150px' }} 
                        />
                    </a>

                    <div className="d-flex align-items-center">
                        {/* Dashboard Menu for Admin Users */}
                        {isAdmin && 3 > 4 && (
                            <div className="dropdown me-3">
                                <button 
                                    className="btn btn-outline-primary btn-sm dropdown-toggle"
                                    type="button"
                                    onClick={() => setShowDashboardMenu(!showDashboardMenu)}
                                >
                                    <FontAwesomeIcon icon={faChartLine} className="me-1" />
                                    Dashboard
                                </button>
                                <ul className={`dropdown-menu ${showDashboardMenu ? 'show' : ''}`} style={{ position: 'absolute', right: 0, left: 'auto' }}>
                                    <li>
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => handleDashboardClick('/dashboard')}
                                        >
                                            <FontAwesomeIcon icon={faChartLine} className="me-2" />
                                            Admin Dashboard
                                        </button>
                                    </li>
                                    <li>
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => handleDashboardClick('/therapist-dashboard')}
                                        >
                                            <FontAwesomeIcon icon={faUserMd} className="me-2" />
                                            Therapist Dashboard
                                        </button>
                                    </li>
                                    <li>
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => handleDashboardClick('/wallet')}
                                        >
                                            <FontAwesomeIcon icon={faWallet} className="me-2 text-primary" />
                                            Wallet
                                        </button>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => handleDashboardClick('/manage-users')}
                                        >
                                            <FontAwesomeIcon icon={faUsers} className="me-2" />
                                            Manage Users
                                        </button>
                                    </li>
                                    <li>
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => handleDashboardClick('/manage-applications')}
                                        >
                                            <FontAwesomeIcon icon={faUserMd} className="me-2" />
                                            Manage Applications
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        )}

                        <FontAwesomeIcon icon={faPowerOff} onClick={exit_acc} />
                    </div>
                </div>
            </nav>

            {/* Overlay to close dropdown when clicking outside */}
            {showDashboardMenu && (
                <div 
                    className="position-fixed" 
                    style={{ top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
                    onClick={() => setShowDashboardMenu(false)}
                />
            )}

            {/* Logout Confirmation Modal */}
            {showLogoutModal && (
                <div
                    className="modal show"
                    tabIndex="-1"
                    style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1050 }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Logout</h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={cancelLogout}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to log out? You will need to sign in again to access your account.</p>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    className="btn btn-secondary" 
                                    onClick={cancelLogout}
                                >
                                    Cancel
                                </button>
                                <button 
                                    className="btn btn-primary" 
                                    onClick={confirmLogout}
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Header;
 